$(document).ready(function () {
	let tmSearch;
	let $form = $('form.vg-search');
	let hSearchContent = $form.find('.vg-search-content');

	var $inputSearch = $('.search-input');

	$inputSearch.on('keyup', function () {
		$('.search-input').not(this).val($(this).val());

		let $self = $(this),
			$self_form = $self.closest('form'),
			target = $self_form.data('target'),
			tabID = $self_form.data('tab-id') || 1,
			$content = $(target),
			search = $self.val();

		clearTimeout(tmSearch);

		if (search) {
			tmSearch = setTimeout(() => {
				$content.addClass('focused');

				$.get('/search/lookup', {search: search}, function (data) {
					if (data.view) {
						$('.vg-search').find('.vg-search-content-body').html(data.view);
						$content.addClass('focused');
						
						let $panes = $content.find('.tab-pane');
						$panes.each(function () {
							let id = $(this).attr('id');
							$(this).attr('id', id + tabID)
						});
						
						let $links = $content.find('.nav-link');
						$links.each(function () {
							let href = $(this).attr('href');
							$(this).attr('href', href + tabID)
						});
					} else {
						$content.removeClass('focused');
					}
				});
			}, 500);
		} else {
			$content.removeClass('focused');
			//$inputSearch.trigger('focus').focus();
		}
	});

	$inputSearch.on('focus', function () {
		var val = $(this).val();
		//if (val) return;

		let $self = $(this),
			$self_form = $self.closest('form'),
			target = $self_form.data('target'),
			tabID = $self_form.data('tab-id') || 1,
			$content = $(target),
			search = $self.val();

		$.get('/search/history', {}, function (data) {
			if (data.view) {
				$content.addClass('focused');
				$('.vg-search').find('.vg-search-content-body').html(data.view);
			} else {
				$content.removeClass('focused');
			}
		});
	});
	
	$(document).mouseup(function (e) {
		if (hSearchContent.has(e.target).length === 0) {
			hSearchContent.removeClass('focused');
		}
	});

	$(document).on('click', '.btn-modal-search-request', function () {
		var $modal = $("#modal-search-request");
		$modal.find('[name=search]').val($(this).data('request'));
		$modal.modal('show');
		return false;
	});

	// mobile search open
	$('[data-toggle=mSearch]').click(function () {
		let $container = $('.vg-hdr-search-mobile__container');

		$container.toggleClass('show');

		return false;
	});
});